import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "quizcard-modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "additional" }
const _hoisted_8 = { class: "question" }
const _hoisted_9 = { class: "additional" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "background" }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.i18n('QUIZCARD_TITLE') + $props.card.id), 1 /* TEXT */),
            _createElementVNode("span", {
              class: "close-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('onClose')))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString($setup.i18n('QUIZCARD_DESCRIPTION')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_8, _toDisplayString($props.card.question[$setup.store.lang]), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_9, _toDisplayString($setup.i18n('QUIZCARD_INSTRUCTION')), 1 /* TEXT */)
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}